import React from 'react';
import { useTranslation } from 'react-i18next';
import parameters from "../../../../../../config/parameters";

const EmptyList =({ gameType, roleInClub }) => {
    const { t } = useTranslation();
    const isAdminMember = (roleInClub === parameters.clubRoles.PLAYER || roleInClub === parameters.clubRoles.AGENT) ? "member" : "admin";
    return (
        <div className={`emptyList ${roleInClub}`}>
            <div className={`emptyListIcon ${gameType}`}></div>
            <p className="emptyText">{t(`club.games.${gameType}.${isAdminMember}`)}</p>
            {(roleInClub === parameters.clubRoles.OWNER || roleInClub === parameters.clubRoles.MANAGER) && 
            <div className={`dialogConfirmBox`}>
                <button className="primary">{t('club.games.renew')}</button>
            </div>}
        </div>
    );
};

export default EmptyList;
